import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { BarType } from './actions';
import { NotificationBarState } from './reducer';
import { StyledNotificationBar, StyledNotificationText } from './styles';
import { StyleColor } from '../../utils/styles-constants';
const I18n = require('react-redux-i18n').I18n;

interface NotificationBarProps {
	notificationBar: NotificationBarState;
	dispatch: Dispatch<StoreState>;
}

class NotificationBar extends React.Component<NotificationBarProps, {}> {

	constructor(props: NotificationBarProps) {
		super(props);
	}

	render() {
		const notifications = this.props.notificationBar.history;

		const errors = notifications.filter((notification, index, self) => {
			return notification.barType === BarType.Error && index === self.findIndex(selfNotification => {
				if (notification.args && selfNotification.args) {
					return selfNotification.message === notification.message
						&& selfNotification.args.id === notification.args.id;
				}
				return selfNotification.message === notification.message;
			});
		});

		const infos = notifications.filter(notification => notification.barType === BarType.Info);

		let info = infos.length > 0
			? I18n.t(`${infos[0].barType}.${infos[0].message}`, infos[0].args)
			: '';
		let error;

		if (errors.length > 1) {
			error = I18n.t(`${errors[0].barType}.bundle_${errors[0].message}`, { number: errors.length });
		} else if (errors.length === 1) {
			error = I18n.t(`${errors[0].barType}.${errors[0].message}`, errors[0].args);
		} else {
			error = '';
		}

		return (
			<StyledNotificationBar isShown={!!notifications.length}>
				{!!errors.length &&
					<StyledNotificationText color={StyleColor.Red}>{error}</StyledNotificationText>
				}
				{!!infos.length &&
					<StyledNotificationText color={StyleColor.White}>{info}</StyledNotificationText>
				}
			</StyledNotificationBar>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { notificationBar } = state;
	return { notificationBar };
};

export default connect(mapStateToProps)(NotificationBar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotificationBar/index.tsx